import { useContext } from 'react';
import { UserTypesContext } from '../context/UserTypesContext';

export function useUser() {
  const { user } = useContext(UserTypesContext);
  return user;
}
